
import { defineComponent } from "vue";
import buttons from "../components/button.vue";

export default defineComponent({
  name: "call to action",
  components: {
    buttons,
  },
});
